import React from 'react';
import PropTypes from 'prop-types';

const Head = ({ config }) => (
  <thead>
    <tr>
      <th className="p-l" colSpan={2}>File</th>
      <th>URL</th>
      <th>Size</th>
      {config?.access?.files_delete
        ? <th>{' '}</th> : null}
    </tr>
  </thead>
);

Head.propTypes = {
  config: PropTypes.object,
};

export default Head;
